module.exports = "/_next/static/images/c448a0288dd8c42f7d211c2d3f6c9819-mulher-perfil-segurando-cartao-lg@1x.jpg";